import { render, staticRenderFns } from "./Referrer.vue?vue&type=template&id=4dbbda20&scoped=true&"
import script from "./Referrer.vue?vue&type=script&lang=js&"
export * from "./Referrer.vue?vue&type=script&lang=js&"
import style0 from "./Referrer.vue?vue&type=style&index=0&id=4dbbda20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbbda20",
  null
  
)

export default component.exports